import { Grid, Stack } from '@chronosphereio/chrono-ui';

export type OptionsEditorColumnProps = {
  /**
   * Components to render in the column. These will usually be
   * `OptionsEditorGroup` components.
   */
  children: React.ReactNode;
};

/**
 * Lay out content in a column within panel options.
 */
export const OptionsEditorColumn = ({ children }: OptionsEditorColumnProps) => {
  return (
    <Grid item xs={12} sm={6} lg={4}>
      <Stack spacing={3}>{children}</Stack>
    </Grid>
  );
};
